import { render, staticRenderFns } from "./MapWarehouse.vue?vue&type=template&id=38d68bf7&scoped=true&"
import script from "./MapWarehouse.vue?vue&type=script&lang=js&"
export * from "./MapWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./MapWarehouse.vue?vue&type=style&index=0&id=38d68bf7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d68bf7",
  null
  
)

export default component.exports